import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const DialOptionBadge = ({ displayValue }: { displayValue: string }) => {
  return (
    <div
      css={css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: ${theme.spacing(2.5)};
        height: ${theme.spacing(2.5)};
        border-radius: ${theme.borderRadius.full};
        font-size: ${theme.fontSize(12)};
        font-weight: ${theme.font.weight.bold};
        background-color: ${theme.colors.neutral50};
        color: ${theme.colors.white};
        user-select: none;
      `}
    >
      {displayValue}
    </div>
  );
};
